import { useEffect, useMemo, useRef, useCallback, useState } from 'react'
import { Form } from 'antd'
import clsx from 'clsx'
import { getCodeUrl, postApi } from 'src/api'
import { INPUT_TYPE, INPUT_ICON } from 'src/@types/enum'
import { I18NS } from 'src/utils'
import s from './input.module.scss'

const { SvgIcon } = livecloud.icons

export function Input(props) {

  const { name, errorTip, title, type } = props

  const rules = useMemo(() => [
    { required: true, message: errorTip },
    type == INPUT_TYPE.EMAIL ? {
      type:    'email',
      message: I18NS.ENTER_VALID_EMAIL_word
    } : null,
    type == INPUT_TYPE.PHONE ? {
      validator: (rule, value) => {
        let reg = /^1[0-9]\d{9}$/
        if (!reg.test(value)) {
          return Promise.reject(I18NS.ENTER_VALID_PHONE_WORD)
        }
        return Promise.resolve()
      }
    } : null,
    type === INPUT_TYPE.AGAIN_PASSWORD ? ({ getFieldValue }) => ({
      validator(_, value) {
        if (!value || getFieldValue('password') === value) {
          return Promise.resolve()
        }
        return Promise.reject(new Error(I18NS.PASSWORD_NOT_SAME_WORD))
      }
    }) : null,
    type == INPUT_TYPE.PHONE_OR_EMAIL ? {
      validator: (rule, value) => {
        let reg = /^1[0-9]\d{9}$/
        if (!reg.test(value) && !value?.includes('@')) {
          return Promise.reject(I18NS.ENTER_VALID_EMAIL_OR_PHONE_WORD)
        }
        return Promise.resolve()
      }
    } : null
  ].filter(t => t), [ type ])

  return (
    <Form.Item
      dependencies={type === INPUT_TYPE.AGAIN_PASSWORD ? [ 'password' ] : undefined}
      rules={rules}
      className={`${s.formItem} formItem`}
      name={name}
    >
      <CustomInput {...props} />
    </Form.Item>
  )
}

function CustomInput({ name, errorTip, value, title, type, onChange, help, ...args }) {

  const [ showPwd, setShowPwd ] = useState(false)

  // 是否报错
  const invalid = !!args['aria-invalid']
  const form = Form.useFormInstance()
  const error = form.getFieldError(name)

  const inputType = useMemo(() => {
    if (
      type == INPUT_TYPE.PASSWORD ||
      type == INPUT_TYPE.AGAIN_PASSWORD
    ) {
      return 'password'
    }
    return 'text'
  }, [ type ])

  const maxLength = useMemo(() => {
    if (
      type == INPUT_TYPE.GET_SMS_CODE ||
      type == INPUT_TYPE.GET_EMAIL_CODE ||
      type == INPUT_TYPE.PHONE_OR_EMAIL_CODE
    ) {
      return 6
    }
    return 40
  }, [ type ])

  // 是否是app
  const isApp = () => {
    if (window.screen.width < 800) {
      return true
    } else {
      return false
    }
  }

  return (
    <div
      className={clsx(`${s.loginInput} formInputBox b-fx b-rel`, invalid && s.invalid)}
    >
      <SvgIcon
        className={`${s.icon} formInputIcon`}
        href={INPUT_ICON[type]}
        size={isApp() ? 20 : 17}
      />
      <input
        className='formInput'
        name={name}
        value={value || ''}
        autoComplete='new-password'
        type={isApp() ? (showPwd ? 'text' : inputType) : inputType}
        placeholder={title}
        maxLength={maxLength}
        onChange={useCallback((e) => onChange(e.target.value), [])}
        onKeyDown={(e) => {
          // 判断是否按下了回车键
          if (e.code === 'Enter') {
            form.submit()
          }
        }}
      />
      {
        (type === INPUT_TYPE.PASSWORD && isApp()) &&
        <SvgIcon
          href={showPwd ? '#LiveCloud-common-xianshi1' : '#LiveCloud-common-yincang1'}
          size={20}
          className={`${s.icon} passShowHideIcon`}
          onClick={() => setShowPwd(!showPwd)}
        />
      }
      {
        (
          type === INPUT_TYPE.GET_EMAIL_CODE ||
          type === INPUT_TYPE.GET_SMS_CODE ||
          type === INPUT_TYPE.PHONE_OR_EMAIL_CODE
        ) && (
          <GetCode form={form} type={type} />
        )
      }
      {type === INPUT_TYPE.IMG_VERIFY && <ImgVerify />}
      <div className={`${s.errorTip} formInputErrorTip b-abs`}>
        {error?.[0] || ''}
      </div>
    </div>
  )
}

function GetCode({ form, type }) {

  const [ { second }, setSecond, getNewState ] = livecloud.useStates(() => ({
    second: Number(localStorage.getItem('cutdown'))
  }))

  useEffect(() => {
    onCountdown()
  }, [])

  const sendCode = useMemo(() => (
    livecloud.debounce(async () => {
      if (getNewState().second > 0) return
      // let account
      let params = {}
      // 邮箱
      // if (type === INPUT_TYPE.GET_EMAIL_CODE) {
      //   try {
      //     const { email } = await form.validateFields([ 'email' ])
      //     account = email
      //   } catch (e) { }
      // }
      // // 手机
      // else {
      //   try {
      //     const { user } = await form.validateFields([ 'user' ])
      //     account = user
      //   } catch (e) { }
      // }
      // 三种情况，手机，邮箱，手机或邮箱，手机或邮箱的时候，需要判断是手机还是邮箱
      // 手机的方法
      const { user, email } = form.getFieldValue()
      const setPhoneParams = (account) => {
        params = {
          userId:    user,
          account,
          loginType: 3
        }
      }
      const setEmailParams = (account) => {
        params = {
          userId:    user || email,
          account,
          loginType: 2
        }
      }
      switch (type) {
        case INPUT_TYPE.GET_EMAIL_CODE:
          try {
            const { email } = await form.validateFields([ 'email' ])
            setEmailParams(email)
          } catch (e) { }
          break
        case INPUT_TYPE.PHONE_OR_EMAIL_CODE:
          try {
            const { phoneOrEmail } = await form.validateFields([ 'phoneOrEmail' ])
            if (phoneOrEmail.includes('@')) {
              setEmailParams(phoneOrEmail)
            } else {
              setPhoneParams(phoneOrEmail)
            }
          } catch (e) { }
          break
        default:
          try {
            const { user } = await form.validateFields([ 'user' ])
            setPhoneParams(user)
          } catch (e) { }
          break
      }

      if (!params) return
      // const res = await postApi('/captcha/sendCode')({
      //   account,
      //   loginType: type === INPUT_TYPE.GET_EMAIL_CODE ? 2 : 3
      // })
      const res = await postApi('/captcha/sendCode')(params)
      if (res.data === livecloud.REQUEST_ERROR) return
      setSecond('second', 60)
      localStorage.setItem('cutdown', 60)
      onCountdown()
    }, 200)
  ), [])

  const onCountdown = useCallback(() => {
    const { second } = getNewState()
    let timer
    if (second > 0) {
      timer = setInterval(() => {
        setSecond('second', pre => {
          const next = pre - 1
          localStorage.setItem('cutdown', next)
          if (next <= 0) clearInterval(timer)
          return next
        })
      }, 1000)
    }
  }, [])

  return (
    <div
      className={`${s.getCode} formGetCode`}
      onClick={sendCode}
    >
      {second < 1 ? I18NS.GET_CHECK_CODE_WORD : I18NS.COUNTDOWN_WORD.replace('{0}', second)}
    </div>
  )
}

function noDebounceSetUrl(dom) {
  return dom.src = getCodeUrl()
}

function ImgVerify() {

  const imgRef = useRef()

  useEffect(() => {
    noDebounceSetUrl(imgRef.current)
  }, [])

  const setCodeUrl = useMemo(() => {
    return livecloud.debounce(() => {
      noDebounceSetUrl(imgRef.current)
    }, 200)
  }, [])

  return (
    <img
      id='imgVerify'
      ref={imgRef}
      className={s.imgVerify}
      onClick={setCodeUrl}
    />
  )
}